<div class="input-group">
  <input type="text" class="form-control" pattern="{{textInputPattern}}"
    [class.is-invalid]="searchFailed"
    [ngbTypeahead]="search"
    [inputFormatter]="formatter"
    [resultFormatter]="formatter"
    [resultTemplate]="rtCustomer"
    [disabled]="disabled"
    [(ngModel)]="selectedCustomer"
    (selectItem)="selectItem($event)"
    (focus)="searchSubject$.next($event.target['value'])"
    (keyup.enter)="searchSubject$.next($event.target.value)"
    placeholder="{{ 'common.placeholders.search.user' | translate }}"/>

    <span class="input-group-text">
      @if (!disabled && (selectedCustomer || searchText)) {
        <button class="btn btn-link btn-sm"
          title="{{ 'common.tooltip.erase' | translate }}"
          (click)="clearInput()">
          <fa-icon [icon]="icons.erase"></fa-icon>
        </button>
      }
    </span>

    @if (searchFailed) {
      <div class="invalid-feedback" translate="users.findCustomer.searchFailed"></div>
    }

    <ng-template #rtCustomer let-user="result" let-t="term">
      <ngb-highlight [result]="formatter(user)" [term]="t"></ngb-highlight>
    </ng-template>
  </div>
